import _ from 'lodash';
import DateHelper from './DateHelper';

/**
 * The selected months, as `selectedDates` holds them: an object keyed by `DateHelper.yearMonthSerialize()`
 * whose values are moments. These read and build that shape for the month header and its picker.
 */

/** Every month from one to the other, both included, in either order, as the first of the month. */
export function monthsBetween(from, to) {
	let start = from.clone().startOf('month');
	let end = to.clone().startOf('month');
	if(end.isBefore(start)) {
		[start, end] = [end, start];
	}
	const months = [];
	for(const month = start.clone(); !month.isAfter(end); month.add(1, 'month')) {
		months.push(month.clone());
	}
	return months;
}

export function selectionFromMonths(months) {
	const selection = {};
	months.forEach((month) => {
		selection[DateHelper.yearMonthSerialize(month)] = month;
	});
	return selection;
}

export function isMonthSelected(selectedDates, month) {
	return !!selectedDates[DateHelper.yearMonthSerialize(month)];
}

/** The earliest and latest selected months, or null when nothing is selected. */
export function selectionBounds(selectedDates) {
	const months = _.values(selectedDates).filter(Boolean);
	if(months.length === 0) {
		return null;
	}
	const sorted = _.sortBy(months, (month) => month.year() * 12 + month.month());
	return {
		first: sorted[0],
		last: sorted[sorted.length - 1],
		count: sorted.length,
	};
}

/**
 * "October 2026" for one month, "Aug – Oct 2026" for a run inside a year, "Nov 2025 – Feb 2026"
 * across one. A selection with a gap in it says how many months it really holds.
 */
export function describeSelection(selectedDates) {
	const bounds = selectionBounds(selectedDates);
	if(!bounds) {
		return '';
	}
	const { first, last, count } = bounds;
	if(count === 1) {
		return first.format('MMMM YYYY');
	}
	const range = first.year() === last.year()
		? `${first.format('MMM')} – ${last.format('MMM YYYY')}`
		: `${first.format('MMM YYYY')} – ${last.format('MMM YYYY')}`;
	const span = monthsBetween(first, last).length;
	return span === count ? range : `${range} (${count} months)`;
}

/**
 * The single month a step back or forward lands on: one before the first selected month, or one
 * after the last, so stepping out of a range leaves the month beside it.
 */
export function steppedMonth(selectedDates, direction) {
	const bounds = selectionBounds(selectedDates);
	if(!bounds) {
		return null;
	}
	return direction < 0
		? bounds.first.clone().startOf('month').subtract(1, 'month')
		: bounds.last.clone().startOf('month').add(1, 'month');
}
